import { render, staticRenderFns } from "./AllScoreTypes.vue?vue&type=template&id=019959f8&"
import script from "./AllScoreTypes.vue?vue&type=script&lang=ts&"
export * from "./AllScoreTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports